import React, { useContext, useEffect, useState } from "react";
import { Button } from "../../../../../stories/Button/Button";
import Close from "../../../../../images/Close.svg";
import { Title } from "../../../../../stories/Title/Title";
import { TextField } from "@mui/material";
import { LabelProps, msgType } from "../../../../../utils/types";
import { Label } from "../../../../../stories/Label/Label";
import Input from "../../../../../stories/Input/Input";
import InputNumber from "../../../../common/Input/InputNumber";
import { ObDetailsType, obFormType } from "../../../../../utils/formTypes";
import { FormikProps } from "formik";
import { useLazyQuery, useMutation } from "@apollo/client";
import {
  AtsStckItemLdgrNodeResult,
  UpdateItemOBResult,
  UpdateItemOBVars,
} from "../queries/types";
import { emptyMessage } from "../../../../../utils/constants";
import { Operation } from "../../../../../utils/Enum.types";
import useToken from "../../../../../customHooks/useToken";
import { AppContext } from "../../../../../context/context";
import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import { handleFormEvent } from "../../../../../utils/UtilFunctions";
import MessageModal from "../../../../../customComponents/MessageModal";
import { payloadTypes } from "../../../../../context/reducer";
import { AtsStckItemLdgrNode } from "../queries/queries";
import { nodeVar } from "../../../../../utils/commonQueryTypes";
import { UpdateStockCompanyItemOB } from "../queries/mutations";
import useLabels from "../../../../../customHooks/useLabels";
import useFormJson from "../../../../../json/useFormJson";
interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}

const OBDetails = ({ setModalFlag }: Props) => {
  const {ItemObForm}=useFormJson();
  const fromJson = [
    {
      labelName: "OB Qty",
      inputName: "obQty",
      dataType: "text",
      autoFocus: true,
      required: true,
    },
    {
      labelName: "Rate",
      inputName: "rate",
      dataType: "text",
      autoFocus: true,
      required: true,
    },
  ];

  const [ObDetailsForm, setObDetailsForm] = useState<ObDetailsType>({
    code: "",
    description: "",
    uom: "",
    category: "",
    sub_category: "",
    manufacturer: "",
    model: "",
    hsn_code: "",
    igst_rate: 0,
    cgst_rate: 0,
    sgst_rate: 0,
  });

  const [formData, setFormData] = useState<obFormType>({
    obQty: "",
    rate: "",
  });

  const { state, dispatch } = useContext(AppContext);

  const { handleToken } = useToken();
const {itemLabel}=useLabels();
  const { user_details } = useLoggedInUserDetails();
  const [message, setMessage] = useState<msgType>(emptyMessage);

  const [GetItemDetails, { data }] = useLazyQuery<
    AtsStckItemLdgrNodeResult,
    nodeVar
  >(AtsStckItemLdgrNode);
  const [UpdateOB] = useMutation<UpdateItemOBResult, UpdateItemOBVars>(
    UpdateStockCompanyItemOB,
    {
      onError: (e) =>
        setMessage({
          flag: true,
          message: e.message,
          operation: Operation.NONE,
        }),
    }
  );
  const handleValueChange = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    const { name, value } = e.target as HTMLInputElement;

    setFormData(() => ({
      ...formData,
      [name]: value,
    }));
  };

  const hanldeSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const token = await handleToken();
      if (token && state.itemLedgerId) {
        UpdateOB({
          variables: {
            input: {
              obQty: Number(formData.obQty),
              obRate: Number(formData.rate),
            },
            itemLdgrID: state.itemLedgerId,
            token,
            user_details,
          },
        }).then(({ data }) => {
          if (data && data.UpdateItemOB) {
            setMessage({
              flag: true,
              message: `Successfully updated ${itemLabel} OB`,
              operation: Operation.CREATE,
            });
          }
        });
      }
    } catch (e) {
      console.error((e as Error).message);
    }
  };

  const handleClear = () => {
    setFormData({
      obQty: "",
      rate: "",
    });
  };
  const handleClose = () => {
    setMessage({
      message: "",
      flag: false,
      operation: Operation.NONE,
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = await handleToken();

        if (token && state.itemLedgerId) {
          GetItemDetails({
            variables: {
              id: state.itemLedgerId,
              token,
            },
          }).then(({ data }) => {
            if (data && data.node) {
              setObDetailsForm({
                code: data.node.item.code,
                description: data.node.item.desc,
                uom: data.node.item.uom,
                category: data.node.item.categoryDetails.categoryName,
                sub_category: "",
                manufacturer: data.node.item.manufacturerDetails.manufacturer,
                model: "",
                hsn_code: data.node.item.hsnCode,
                igst_rate: data.node.item.igst,
                cgst_rate: data.node.item.cgst,
                sgst_rate: data.node.item.sgst,
              });
              if (data.node.stkOb) {
                setFormData({
                  obQty: data.node.stkOb.toString(),
                  rate: data.node.stkObRate.toString(),
                });
              }
            }
          });
        }
      } catch (e) {
        console.error((e as Error).message);
      }
    };

    fetchData();
  }, [GetItemDetails, state.itemLedgerId, data]);

  return (
    <>
      <form className="item-ob__entry" onSubmit={hanldeSubmit}>
        <div className="item-ob__entry--title">
          <Title>Stock {itemLabel} Opening Balance Entry</Title>
          <img src={Close} alt="" onClick={() => setModalFlag(false)} />
        </div>
        <div className="item-ob__entry--select">
          <div className="item-ob__entry--select--grid">
            {ItemObForm.ObDetails.map((res: LabelProps, index: React.Key) => {
              return (
                <React.Fragment key={index}>
                  <TextField
                    className="item-ob__entry--textfield"
                    label={res.labelName}
                    slotProps={{
                      inputLabel: { shrink: true },
                    }}
                    value={ObDetailsForm[res.inputName]}
                    disabled
                  />
                </React.Fragment>
              );
            })}
          </div>
        </div>
        <div className="item-ob__entry--block">
          <div className="item-ob__entry--block--details">
            <Title>Enter OB Details</Title>
            <br />

            {fromJson.map((itm, index) => {
              return (
                <React.Fragment key={index}>
                  <Label>{itm.labelName}</Label>
                  <InputNumber
                    name={itm.inputName}
                    value={formData[itm.inputName]}
                    onChange={handleValueChange}
                    onKeyDown={handleFormEvent}
                  />
                </React.Fragment>
              );
            })}
          </div>
        </div>
        <Button mode="save" type="submit" />
        <Button mode="clear" type="button" />
        <Button
          mode="cancel"
          onClick={() => {
            dispatch({
              type: payloadTypes.SET_ITEM_LEDGER_ID,
              payload: { itemLedgerId: 0 },
            });
            setModalFlag(false);
          }}
        />
      </form>
      <MessageModal
        handleClose={handleClose}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
    </>
  );
};

export default OBDetails;
